module.exports = __webpack_public_path__ + "static/media/mouthPucker.3e60ed06.obj";